'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Components = require('./Components');

var _components = require('components');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Rules = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(Rules, _Component);

  function Rules() {
    (0, _classCallCheck3.default)(this, Rules);
    return (0, _possibleConstructorReturn3.default)(this, (Rules.__proto__ || (0, _getPrototypeOf2.default)(Rules)).apply(this, arguments));
  }

  (0, _createClass3.default)(Rules, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          rules = _props.rules,
          onChangeInclude = _props.onChangeInclude,
          onChangeFormat = _props.onChangeFormat,
          saveState = _props.saveState;


      var BTN_SIZES = _components.ENTERPRISE_BUTTON_SIZES;
      var BTN_TYPES = _components.ENTERPRISE_BUTTON_TYPES;
      var styles = require('./Rules.scss');

      return _react2.default.createElement(
        'div',
        { className: styles.root },
        _react2.default.createElement(_Components.Header, null),
        _react2.default.createElement(_Components.HostContainer, { rules: rules,
          onChangeInclude: onChangeInclude,
          onChangeFormat: onChangeFormat,
          saveState: saveState
        }),
        _react2.default.createElement(_Components.NonHostContainer, null)
      );
    }
  }]);
  return Rules;
}(_react.Component), _class.propTypes = {
  rules: _react.PropTypes.object,
  onChangeInclude: _react.PropTypes.func,
  onChangeFormat: _react.PropTypes.func,
  saveState: _react.PropTypes.func
}, _temp);
exports.default = Rules;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Rules/Rules.jsx
// module id = 1465
// module chunks = 0